import axios from "axios";
import { handlerError } from "utils";

export const getPendingTerms = async () => {
    try {
        const { data } = await axios.get(`/user/me/terms/pending`);
        return {
            pendingTerms: data?.pendingTerms ?? [],
            termsStatus: data?.termsStatus ?? null,
        };
    } catch (ex) {
        handlerError(ex);
        return { pendingTerms: [], termsStatus: null };
    }
};

export const getTermPreview = async (termVersionId) => {
    try {
        const { data } = await axios.get(`/user/me/terms/${termVersionId}/preview`);
        return data?.termVersion ?? null;
    } catch (ex) {
        handlerError(ex);
        return null;
    }
};

export const acceptTerms = async (channel = "backoffice") => {
    try {
        const { data } = await axios.post(`/user/me/terms/accept`, { channel });
        return data;
    } catch (ex) {
        handlerError(ex);
        throw ex;
    }
};
